import styled from 'styled-components';

export const StyledContainer = styled.div`
  .cardWrapper {
    .container {
      padding: 0 0.5rem;
    }
    .icon-arrow-right-external {
      position: initial;
    }
    .carousal_header--cta {
      button {
        background-color: transparent;
        color: inherit;
      }
    }
    .glide__slides_authoring {
      @media only screen and (min-width: 767px) {
        flex-wrap: nowrap !important;
      }
    }
  }

  .m-badge-overlay-merch {
    background-color: rgb(255, 153, 98);
  }

  .feature-header {
    line-height: 1;
  }

  .hideCarousel {
    display: none;
  }
`;

export const StyledOfferCardsDiv = styled.div``;
export const StyledOfferCardsDivPreviewMode = styled.div`
  pointer-events: none;
`;
